import { call, put, select } from 'redux-saga/effects';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import {
  activeLibraryChanged,
  selectActiveLibraryType,
  selectOriginalDefaultLibraryType,
} from 'features/content-library/contentLibrarySlice';
import { ContentLibraryType } from 'features/content-library/types';

export function* configureActiveLibraryTypeSaga() {
  const canManageLibrary: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.manageContentLibrary
  );
  const canManagePersonalContentLibrary: boolean = yield call(
    hasPermissionsSaga,
    PermissionTypes.managePersonalContentLibrary
  );

  const currentActiveLibraryType: ContentLibraryType = yield select(selectActiveLibraryType);

  // If user has both permissions, restore the original backend default if needed
  if (canManageLibrary && canManagePersonalContentLibrary) {
    const originalDefaultLibraryType: ContentLibraryType | null = yield select(
      selectOriginalDefaultLibraryType
    );

    // If we have an original default and current type doesn't match it, restore it
    if (originalDefaultLibraryType && currentActiveLibraryType !== originalDefaultLibraryType) {
      yield put(activeLibraryChanged(originalDefaultLibraryType));
    }

    return;
  }

  let expectedLibraryType: ContentLibraryType;

  if (canManagePersonalContentLibrary) {
    expectedLibraryType = 'personal';
  } else {
    expectedLibraryType = 'room';
  }

  if (currentActiveLibraryType !== expectedLibraryType) {
    yield put(activeLibraryChanged(expectedLibraryType));
  }
}
